import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { publicEmergencyAck } from '@/lib/api/endpoints';
import { publicGet, publicPost } from '@/lib/api/publicClient';

export interface EmergencyAcknowledgementLanding {
  dispatchId: string;
  status: 'PENDING' | 'ACKNOWLEDGED' | 'ESCALATED' | 'CANCELLED';
  isExpired: boolean;
  acknowledgementDueAt: string;
  acknowledgedAt?: string | null;
  escalatedAt?: string | null;
  appointment: {
    customerName: string;
    serviceName: string;
    address: string;
    startAt: string;
    endAt: string;
    timezone: string;
  };
  technicianName: string;
  supervisorName?: string | null;
  tenantName: string;
}

export function useEmergencyAcknowledgement(token: string) {
  const queryClient = useQueryClient();
  const queryKey = ['public', 'emergency-ack', token] as const;
  const landing = useQuery<EmergencyAcknowledgementLanding>({
    queryKey,
    queryFn: () => publicGet<EmergencyAcknowledgementLanding>(publicEmergencyAck.landing(token)),
    enabled: Boolean(token),
    retry: false,
  });
  const acknowledge = useMutation({
    mutationFn: () => publicPost(publicEmergencyAck.acknowledge(token)),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });
  return { ...landing, acknowledge };
}
